import { axiosInstance } from "./axios-interceptors";

const report = {
  getSource: async (source, query) => {
    return (
      await axiosInstance.get(`/v1/${source}/search`, {
        params: {
          limit: 20,
          query,
        },
      })
    ).data;
  },
  getClientEntity: async (query) => {
    return (
      await axiosInstance.get("/v1/client-entities/search", {
        params: {
          limit: 20,
          query,
        },
      })
    ).data;
  },
  getVessel: async (query) => {
    return (
      await axiosInstance.get("/v1/vessels/search", {
        params: {
          limit: 20,
          query,
        },
      })
    ).data;
  },
  getReport: async (query) => {
    return (
      await axiosInstance.get("/v1/pivot-report", {
        params: {
          limit: 999999,
          page: 1,
          "source-type": "finance",
          ...query,
        },
      })
    ).data;
  },
  getCPStatus: async () => {
    return (await axiosInstance.get("/v1/pivot-report/get-cp-status")).data;
  },
  getTemplates: async () => {
    return (
      await axiosInstance.get("/v1/report-templates/get-by-roles", {
        params: {
          limit: 99999,
        },
      })
    ).data;
  },
  getTemplateDetail: async (id: string) => {
    return (await axiosInstance.get(`/v1/report-templates/${id}`)).data;
  },
  getData: async (id: string, filter: any) => {
    return (
      await axiosInstance.post(`/v1/report-templates/${id}/get-data`, {
        filter,
        limit: 999999,
      })
    ).data;
  },
};

export default report;
